import { Injectable, signal } from '@angular/core';

import { CreateAccountInput } from '../../../domain/user/dtos/create-account.input';

export type AddressFormValue = Partial<
  Pick<
    CreateAccountInput,
    'cep' | 'rua' | 'estado' | 'cidade' | 'bairro' | 'numero' | 'complemento'
  >
> & { noNumberAddress?: boolean; termos?: boolean };

@Injectable()
export class AccountFormHandler {
  private step = signal(0);
  private profileInfo = signal<Partial<CreateAccountInput> | null>(null);
  private addressInfo = signal<AddressFormValue | null>(null);
  private addressWithoutCep = signal(false);
  private accountInfo = signal<Partial<Record<string, any>> | null>(null);
  private extraInfo = signal<Partial<Record<string, any>> | null>(null);

  getStep(): number {
    return this.step();
  }

  setStep(step: number): void {
    this.step.set(step);
  }

  backStep(): void {
    this.step.set(this.step() - 1);
  }

  nextStep(): void {
    this.step.set(this.step() + 1);
  }

  getProfileInfo(): Partial<CreateAccountInput> | null {
    return this.profileInfo();
  }

  setProfileInfo(data: Partial<CreateAccountInput>): void {
    this.profileInfo.set(data);
  }

  getAddressInfo(): AddressFormValue | null {
    return this.addressInfo();
  }

  setAddressInfo(data: AddressFormValue): void {
    this.addressInfo.set(data);
  }

  isAddressWithoutCep(): boolean {
    return this.addressWithoutCep();
  }

  setAddressWithoutCep(value: boolean): void {
    this.addressWithoutCep.set(value);
  }

  getAccountInfo(): Record<string, any> | null {
    return this.accountInfo();
  }

  setAccountInfo(data: Record<string, any>): void {
    this.accountInfo.set(data);
  }

  getExtraInfo(): Record<string, any> | null {
    return this.extraInfo();
  }

  setExtraInfo(data: Record<string, any>): void {
    this.extraInfo.set(data);
  }

  /** O checkbox de termos fica no formulário de conta ou, sem senha, no de endereço (último passo). */
  hasAcceptedTerms(): boolean {
    return this.accountInfo()?.['termos'] === true || this.addressInfo()?.termos === true;
  }

  getCompleteInfo(): CreateAccountInput {
    const address = this.addressInfo() ?? {};
    const { noNumberAddress: _noNumber, termos: _termos, ...addressForApi } = address;
    // `termos` é estado de tela; o que vai para a API é o `termsAccepted`.
    const { termos: _accountTermos, ...accountForApi } = this.accountInfo() ?? {};
    return {
      ...(this.profileInfo() ?? {}),
      ...addressForApi,
      ...accountForApi,
      ...(this.extraInfo() ?? {}),
    } as CreateAccountInput;
  }
}
